import styled from '@emotion/styled';

const ModalTextDiv = styled.div`
  margin: 0 0 20px 0;
`;

export {ModalTextDiv};
